import base from './base';

export default {
  ...base,
  name: 'local',
  herbieApiHost: 'http://localhost:3000/herbie-1.1',
  apiHost: 'http://localhost:3000',
  apiV2: 'http://localhost:3005/v2',
  experience: 'http://localhost:8080/public',
  sentryDsn: '',
  segmentAnalyticsKey: '',
  googleMapsKey: 'AIzaSyDhGp8Wx17GWE4XHW8n1IGNi2RbUVYmGFY',
  cobliInviteUrl: 'https://cadastro-local.cobli.co/invites',
  graphqlHost: 'http://localhost:4000',
  cerberusHost: '',
  launchDarklyId: '5b69f3c2ffcc3e1ec6336136',
  clarityId: '',
  geofenceApiHost: 'https://api.cobli.co/v3/geofences',
  alertsApiHost: 'https://api.cobli.co/v1/triggers',
};
